export default {
    SUCESS_LABEL: 'success',
    SUCESS_CREATION_FORM: 'Le formulaire a bien été soumis',
    ERROR_LABEL: 'danger',
    ERROR_CREATION_FORM: 'Erreur lors de la soumission du formulaire',
};
